require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-manual-test-engineer.json") })
        }
      }, "path---careers-manual-test-engineer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-manual-test-engineer!./.cache/json/careers-manual-test-engineer.json
// module id = 869
// module chunks = 231608221292675